import { Block, Typography } from '@aloft/toolkit-sui';

import { borderColor, borderWidth } from '../../../../styles/border.js';
import { ContentfulUpdatesList } from '../UpdatesList/ContentfulUpdatesList.js';

export const Updates = () => {
  return (
    <Block
      height="100%"
      width="100%"
      borderLeftWidth={borderWidth}
      borderColor={borderColor}
      borderStyle="solid"
      backgroundColor="surface1"
      paddingX="1.5rem"
      paddingY=".1rem"
      overflowY="auto"
    >
      <Block marginBottom=".5rem">
        <Typography variant="h1">Updates</Typography>
      </Block>
      <ContentfulUpdatesList />
    </Block>
  );
};
